import React, { useState, useEffect, Fragment } from 'react';
import { Stack, TextField, Box, Button, CircularProgress, Typography, Card, CardActions, CardContent, CardHeader, DateTime } from '@mui/material';

import { useNotify } from 'react-admin'
import client from '../common/client';
import Help from '../component/Help'
import ProjectS3CreateButton from './ProjectS3CreateButton'

const ProjectBackendS3Create = props => {
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);

    const distributeNow = (e) => {
        setLoading(true)
        client.request_get(`/api/distribution/front/config/${props.project.id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Distrubute Success`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    useEffect(() => {

    }, [props.project])

    return (
        <Card >
            <CardHeader
                title="Create S3 Bucket"
                action={
                    <Help />
                }
            />
            <CardContent>
                <Box m={1}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <div>{props.project.backend_s3_admin}</div>
                        <ProjectS3CreateButton project_id={props.project.id} s3={props.project.backend_s3_admin} />
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProjectBackendS3Create;
